<template>
    <component
        class="ui-link"
        v-sanitize-href="link"
        :target="resolvedTarget"
        :to="tag === 'router-link' ? to : undefined"
        :is="tag"
        :class="[
            variant ? `ui-link--${variant}` : '',
            weight ? `ui-link--${weight}` : '',
            {
                'ui-link--underline': underline,
                'ui-link--external': external,
            },
        ]"
    >
        <slot></slot>
        <i
            v-if="external"
            class="fas fa-external-link-alt ui-link__external-icon"
            aria-hidden="true"
        ></i>
    </component>
</template>

<script>
export default {
    name: 'UiLink',
    props: {
        link: {
            type: String,
            default: null,
            required: false,
        },
        target: {
            type: String,
            default: null,
            required: false,
        },
        to: {
            type: [String, Object],
            default: null,
            required: false,
        },
        variant: {
            type: String,
            default: 'primary',
            required: false,
        },
        weight: {
            type: String,
            default: 'bold',
            required: false,
        },
        underline: {
            type: Boolean,
            default: false,
            required: false,
        },
        external: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return {
            tag: 'button',
        };
    },
    created() {
        if (this.canUseRouterLink(this.to)) {
            this.tag = 'router-link';
        } else if (this.link) {
            this.tag = 'a';
        } else {
            this.tag = 'span';
        }
    },
    methods: {
        canUseRouterLink(to) {
            if (!to || !this.$router) {
                return false;
            }
            if (typeof to === 'string') {
                return this.$router.resolve(to).matched.length > 0;
            }
            if (to.name) {
                return this.$router.hasRoute(to.name);
            }
            if (to.path) {
                return this.$router.resolve(to.path).matched.length > 0;
            }
            return false;
        },
    },
    computed: {
        resolvedTarget() {
            if (this.target) {
                return this.target;
            }
            if (this.external) {
                return '_blank';
            }
            return null;
        },
    },
};
</script>

<style lang="scss" scoped>
.ui-link {
    text-decoration: none;
    transition: 500ms all;
    
    &--primary {
        color: $ecart-accent;

        &:hover {
            color: rgba($ecart-accent, 0.7);
        }
    }

    &--secondary {
        color: $ecart-secondary-600;

        &:hover {
            color: rgba($ecart-secondary-600, 0.7);
        }
    }

    &--global {
        color: $ecart-primary;

        &:hover {
            color: rgba($ecart-primary, 0.7);
        }
    }

    &--regular {
        font-weight: 400;
    }

    &--medium {
        font-weight: 500;
    }

    &--bold {
        font-weight: 700;
    }

    &--underline {
        text-decoration: underline;
    }

    &--external {
        font-size: 0.8125rem;
    }

    &__external-icon {
        font-size: 0.65rem;
        margin-left: 4px;
        opacity: 0.75;
    }
}
</style>
